import GenericCard from "components/UI/GenericCard/GenericCard";
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const WinRateOverTime = ({ winRateOverTime = {} }) => {
  const chartData = Object.values(winRateOverTime).map((item) => ({
    date: new Date(item.date).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    }),
    winRate: item.winRate,
    fullDate: item.date,
  }));

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="p-3 border border-gray-600 rounded-lg shadow-lg bg-[#111827] ">
          <p className="text-gray-300 text-sm">
            {new Date(data.fullDate).toLocaleDateString()}
          </p>
          <p className="text-blue-600 font-semibold">
            Win Rate: {payload[0].value.toFixed(2)}%
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <GenericCard
      title="Win Rate Over Time"
      disableToggle
      className="table-card [&>.content]:p-0 [&>.content]:overflow-hidden [&>.content]:h-full"
    >
      <ResponsiveContainer width="100%" height="100%" minHeight={525}>
        <LineChart
          data={chartData}
          margin={{
            top: 20,
            right: 20,
            left: 0,
            bottom: 20,
          }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="#374151"
            strokeOpacity={1}
          />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 12 }}
            stroke="#9ca3af"
            minTickGap={30}
          />
          <YAxis
            domain={["dataMin - 5", "dataMax + 5"]}
            tick={{ fontSize: 12 }}
            stroke="#9ca3af"
            tickFormatter={(value) => `${value}%`}
          />
          <Tooltip content={<CustomTooltip />} />
          <Line
            type="monotone"
            dataKey="winRate"
            stroke="#3b82f6"
            strokeWidth={2}
            isAnimationActive={false}
            dot={{ fill: "#3b82f6", r: 2.5 }}
            activeDot={{ r: 5, stroke: "#3b82f6", strokeWidth: 2 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </GenericCard>
  );
};

export default WinRateOverTime;
